<div class="modal-header">
  <h2 class="modal-title mb-0 fs-3 fw-bold">{{ data.title | translate: data.data }}</h2>
</div>
<div class="modal-body" [innerHTML]="data.content | translate: data.data"></div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="cancel()">
    {{ 'confirmation-dialogue.no' | translate }}
  </button>
  <button class="btn btn-warning" (click)="confirm()">
    {{ 'confirmation-dialogue.yes' | translate }}
  </button>
</div>
